import { api } from "utils";
import { PUBLIC_V1 } from "constant/URL";
import { objectToQueryParams } from "utils/objectToQueryParams";

export const getListListingOffice = async (params = {}) => {
  const newParams = (!!params && typeof params === "object") ? `&${objectToQueryParams(params)}` : ""
  return api({}, true).get(`/${PUBLIC_V1}/module/property/offices?${newParams}`)
}

export const getListListingInactive = async (params = {}) => {
  const newParams = (!!params && typeof params === "object") ? `&${objectToQueryParams(params)}` : ""
  return api({}, true).get(`/${PUBLIC_V1}/properties/inactive-six-months?${newParams}`)
}

export const transferListing = async (slug = "", params) => {
  return api({}, true).patch(`/${PUBLIC_V1}/module/property/my-listings/${slug}/transfer`, params)
}

export const getListListingDetail = async (slug = "") => {
  return api({}, true).get(`/${PUBLIC_V1}/module/property/my-listings/${slug}`)
}

export const getListingImages = async (slug = "") => {
  return api({}, true).get(`/${PUBLIC_V1}/properties/${slug}/property-images`)
}

export const getDetailListingOffice = async (slug = "") => {
  return api({}, true).get(`/${PUBLIC_V1}/module/property/offices/${slug}`)
}

export const activeBulkProperties = async (params) => {
  return api({}, true).post(`/${PUBLIC_V1}/properties/active-bulk`, params)
}

export const deleteBulkProperties = async (params) => {
  return api({}, true).post(`/${PUBLIC_V1}/properties/delete-bulk`, params)
}

export const getListLocation = async (params = {}) => {
  const newParams = (!!params && typeof params === "object") ? `?${objectToQueryParams(params)}` : ""
  return api({}, true).get(`/${PUBLIC_V1}/module/portal/locations${newParams}`)
}